// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#category .vs__dropdown-option--disabled{color:#000;font-weight:700;margin-left:0!important}#category .vs__dropdown-option--disabled:hover{background:#fff}#category .vs__dropdown-option{margin-left:.3rem}", ""]);
// Exports
module.exports = exports;
